/**
 * Card numbers recognized by the test-payment flow (PAY-52048).
 *
 * The Cashier widget shows them in the buyer-facing testing instructions, and the
 * `payments-cc-form` test tokenization accepts exactly these PANs, so both packages
 * must import them from here. The numbers are part of the cross-repository contract
 * with the backend Test payment provider — do not change them independently.
 */
export const TestPaymentCards = {
  approved: '4111111111111111',
  declined: '4000000000000002'
};

/** Formats a PAN in 4-digit groups for display, e.g. `4111 1111 1111 1111`. */
export const formatTestCardNumber = pan => pan.replace(/(\d{4})(?=\d)/g, '$1 ');
//# sourceMappingURL=testPaymentCards.js.map